"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto p-4" };
const _hoisted_2 = { class: "text-2xl pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = {
    key: 0,
    class: "filters justify-between lg:items-end"
};
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const vue_3 = require("vue");
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const vue_router_1 = require("vue-router");
const Form_1 = require("../../components/Form");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const shop_1 = require("../../common/utils/shop");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TargetNumbers',
    setup(__props) {
        var _a, _b, _c;
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const router = (0, vue_router_1.useRouter)();
        const targetNumbers = (0, vue_3.ref)([]);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const searchCustomerId = (0, vue_3.ref)('');
        const companyData = ShopConfig_1.ShopConfig.getCompanyData();
        const targetNumberFields = (0, vue_3.ref)([
            {
                key: "planId",
                label: (_a = (0, i18n_1.trans)("planId", "Plan ID", "target_numbers")) !== null && _a !== void 0 ? _a : "Plan ID",
                value: "planId",
            },
            {
                key: "plannedTrade",
                label: (_b = (0, i18n_1.trans)("plannedTrade", "Planned Trade", "target_numbers")) !== null && _b !== void 0 ? _b : "Planned Trade",
                value: "plannedTrade",
            },
            {
                key: "actualTrade",
                label: (_c = (0, i18n_1.trans)("actualTrade", "Actual Trade", "target_numbers")) !== null && _c !== void 0 ? _c : "Actual Trade",
                value: "actualTrade",
            },
        ]);
        (0, vue_3.onMounted)(() => {
            getTargetNumbers();
        });
        const getTargetNumbers = async () => {
            var _a;
            let param = { userId: (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.id };
            if (searchCustomerId.value) {
                param['customerId'] = searchCustomerId.value;
            }
            const targetNumber = await (0, fetch_1.default)(router.resolve({ name: 'queries_target_numbers_api', query: Object(param) }).href, { method: 'GET' });
            targetNumbers.value = [];
            if (targetNumber != '') {
                let parsedTargetNumbers = JSON.parse(targetNumber.toString());
                parsedTargetNumbers.forEach(element => {
                    if (element.isRevenue == true) {
                        element.actualTrade = (0, shop_1.formatPrice)(element.actualTrade, companyData.currencyCode);
                        element.plannedTrade = (0, shop_1.formatPrice)(element.plannedTrade, companyData.currencyCode);
                    }
                    else {
                        element.actualTrade = (0, shop_1.formatUnit)(element.actualTrade, { unit: 'db' });
                        element.plannedTrade = (0, shop_1.formatUnit)(element.plannedTrade, { unit: 'db' });
                    }
                    targetNumbers.value.push(element);
                });
                targetNumbers.value.sort((a, b) => (a['isRevenue'] - b['isRevenue']));
            }
        };
        return (_ctx, _cache) => {
            var _a;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("target_numbers", "Target Numbers", "target_numbers")), 1),
                ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).TARGET_NUMBER_READ_ALL))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                type: "text",
                                name: "id",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_id_placeholder', 'Customer ID', 'target_numbers'),
                                required: "",
                                border: "",
                                icon: "marso-icon-user",
                                modelValue: searchCustomerId.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchCustomerId).value = $event))
                            }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (getTargetNumbers()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("search", "Search", "target_numbers")), 1)
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: targetNumberFields.value,
                    items: targetNumbers.value,
                    condensed: "",
                    stripes: ""
                }, null, 8, ["fields", "items"])
            ]));
        };
    }
});
